import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMaxQuantity } from '../get-max-quantity';
export let IssueType = /*#__PURE__*/function (IssueType) {
  IssueType["OutOfStock"] = "OUT_OF_STOCK";
  IssueType["LowStock"] = "LOW_STOCK";
  IssueType["NotEnoughStock"] = "NOT_ENOUGH_STOCK";
  return IssueType;
}({});
export let IssueSeverity = /*#__PURE__*/function (IssueSeverity) {
  IssueSeverity["Warning"] = "WARNING";
  IssueSeverity["Error"] = "ERROR";
  return IssueSeverity;
}({});
export const OUT_OF_STOCK_MESSAGE = 'Out of stock';
const getIssueTypeWithMessage = function () {
  let issues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let type = arguments.length > 1 ? arguments[1] : undefined;
  let message = arguments.length > 2 ? arguments[2] : undefined;
  const issue = (issues || []).find(iss => iss.type === type);
  if (issue) {
    return _objectSpread(_objectSpread({}, issue), {}, {
      message
    });
  }
  return null;
};
const getLowStockPDPMessage = maxQuantity => "Low stock, ".concat(maxQuantity, " available");
export const getOutOfStockCartIssue = () => ({
  message: 'Out of stock, remove item to continue',
  severity: IssueSeverity.Error
});
export const getOutOfStockCheckoutIssue = () => ({
  message: 'Out of stock, remove item in cart to continue',
  severity: IssueSeverity.Error
});
export const getLowStockCartIssue = (maxQuantity, canFulfil) => ({
  message: canFulfil ? "Low stock, ".concat(maxQuantity, " available") : "".concat(maxQuantity, " available, reduce quantity to continue"),
  severity: canFulfil ? IssueSeverity.Warning : IssueSeverity.Error
});
const getLowStockCheckoutIssue = (maxQuantity, canFulfil) => ({
  message: canFulfil ? "Low stock, ".concat(maxQuantity, " available") : "".concat(maxQuantity, " available, reduce quantity in cart to continue"),
  severity: canFulfil ? IssueSeverity.Warning : IssueSeverity.Error
});
export const getCartItemIssueText = (issues, maxQuantity, isCartPage) => {
  if (!issues.length) {
    return null;
  }
  if (issues[0].type === IssueType.OutOfStock) {
    return isCartPage ? getOutOfStockCartIssue() : getOutOfStockCheckoutIssue();
  }
  return isCartPage ? getLowStockCartIssue(maxQuantity, issues[0].type === IssueType.LowStock) : getLowStockCheckoutIssue(maxQuantity, issues[0].type === IssueType.LowStock);
};
const getMaxVariantQuantity = variants => variants.reduce((maxQuantity, variant) => Math.max(maxQuantity, getMaxQuantity(variant)), 0);
export const getProductStockIssue = (variants, selectedVariant) => {
  const productVariants = selectedVariant ? [selectedVariant] : variants;
  const outOfStockIssues = productVariants.flatMap(_ref => {
    var _getIssueTypeWithMess;
    let {
      issues
    } = _ref;
    return (_getIssueTypeWithMess = getIssueTypeWithMessage(issues, IssueType.OutOfStock, OUT_OF_STOCK_MESSAGE)) !== null && _getIssueTypeWithMess !== void 0 ? _getIssueTypeWithMess : [];
  });
  if (outOfStockIssues.length === productVariants.length) {
    return outOfStockIssues[0];
  }
  const lowStockIssue = getIssueTypeWithMessage((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.issues) || [], IssueType.LowStock, getLowStockPDPMessage(getMaxVariantQuantity(productVariants)));
  if (lowStockIssue) {
    return lowStockIssue;
  }
  return null;
};
export const getProductListingIssue = function () {
  let issues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return getIssueTypeWithMessage(issues, IssueType.OutOfStock, OUT_OF_STOCK_MESSAGE);
};